import { writable} from "svelte/store";


const  valores=writable(localStorage.getItem("login") || "");


export default valores; 